<template>
  <div class="matchbymatch-summary">
    <template v-if="windowWidth > 1200">
      <BCarousel
        :key="updateC"
        :interval="5000"
        :autoplay="false"
        :indicator-inside="false"
        :pause-info="true"
        :progress="false"
      >
        <template v-for="(item, index1) in games">
          <template v-if="index1 % 6 === 0">
            <BCarouselItem :key="index1">
              <div class="cont-row-statstype">
                <template v-for="(val, index) in indexPc">
                  <template v-if="index1 + val < games.length">
                    <SummaryMatchContainer
                      :data="games[index1 + val]"
                      :matchs="matchs"
                      :position="player.position_id"
                      :type="type"
                      :key="`sm${index}`"
                    />
                  </template>
                </template>
              </div>
            </BCarouselItem>
          </template>
        </template>
      </BCarousel>
    </template>
    <template v-if="windowWidth > 768 && windowWidth <= 1200">
      <BCarousel
        :key="updateC"
        :interval="5000"
        :autoplay="false"
        :indicator-inside="false"
        :pause-info="true"
        :progress="false"
      >
        <template v-for="(item, index2) in games">
          <template v-if="index2 % 4 === 0">
            <BCarouselItem :key="index2">
              <div class="cont-row-statstype">
                <template v-for="val in indexPcMedium">
                  <template v-if="index2 + val < games.length">
                    <SummaryMatchContainer
                      :data="games[index2 + val]"
                      :matchs="matchs"
                      :position="player.position_id"
                      :type="type"
                    />
                  </template>
                </template>
              </div>
            </BCarouselItem>
          </template>
        </template>
      </BCarousel>
    </template>
    <template v-if="windowWidth > 500 && windowWidth <= 768">
      <BCarousel
        :key="updateC"
        :interval="5000"
        :autoplay="false"
        :indicator-inside="false"
        :pause-info="true"
        :progress="false"
      >
        <template v-for="(item, index3) in games">
          <template v-if="index3 % 2 === 0">
            <BCarouselItem :key="index3">
              <div class="cont-row-statstype">
                <template v-for="val in indexTablet">
                  <template v-if="index3 + val < games.length">
                    <SummaryMatchContainer
                      :data="games[index3 + val]"
                      :matchs="matchs"
                      :position="player.position_id"
                      :type="type"
                    />
                  </template>
                </template>
              </div>
            </BCarouselItem>
          </template>
        </template>
      </BCarousel>
    </template>
    <template v-if="windowWidth <= 500">
      <BCarousel
        :key="updateC"
        :interval="5000"
        :autoplay="false"
        :indicator-inside="false"
        :pause-info="true"
        :progress="false"
      >
        <template v-for="(item, index4) in games">
          <BCarouselItem :key="index4">
            <div class="cont-row-statstype">
              <SummaryMatchContainer :data="item" :matchs="matchs" :position="player.position_id" :type="type" />
            </div>
          </BCarouselItem>
        </template>
      </BCarousel>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SummaryMatchContainer from '@/components/Elements/SummaryMatchContainer';
export default {
  name: 'MatchByMatch',
  components: {
    SummaryMatchContainer,
  },
  props: {
    matchs: {
      type: Array,
      default: () => [],
    },
    games: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Number,
      default: 1,
    },
    player: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      indexPc: [0, 1, 2, 3, 4, 5],
      indexPcMedium: [0, 1, 2, 3],
      indexTablet: [0, 1],
      indexMovil: [0],
      updateC: 0,
    };
  },
  watch: {
    windowWidth() {
      if (this.windowWidth > 1200) {
        this.updateC += 1;
      }
      if (this.windowWidth > 768 && this.windowWidth <= 1200) {
        this.updateC += 1;
      }
      if (this.windowWidth > 500 && this.windowWidth <= 768) {
        this.updateC += 1;
      }
      if (this.windowWidth <= 500) {
        this.updateC += 1;
      }
    },
  },
  computed: {
    ...mapState(['windowWidth']),
  },
  methods: {},
};
</script>
<style>
.matchbymatch-summary {
  padding-bottom: 30px;
}
.matchbymatch-summary .carousel-arrow .icon {
  color: #ffffff;
  width: 140px;
  border-radius: 6px;
  background-color: rgba(19, 40, 57, 0.4);
}

/* bug-cambio 560*/
.progress.is-primary1::-webkit-progress-value {
  background-color: #cbee6b;
}

.progress.is-primary1::-moz-progress-bar {
  background-color: #cbee6b;
}

.progress.is-primary1::-ms-fill {
  background-color: #cbee6b;
}

.progress.is-primary1:indeterminate {
  background-image: linear-gradient(to right, #cbee6b 30%, #ededed 30%);
}
/* bug-cambio 560*/
.matchbymatch-summary .carousel-indicator {
  /* display: none !important; */
  margin-top: -30px;
  position: absolute;
}
.matchbymatch-summary .carousel-arrow.is-hovered {
  opacity: 1 !important;
}
.is-fullheight-with-navbar-and-footer,
.is-fullheight-with-navbar-and-footer-mobile {
  height: 100%;
}

.matchbymatch-summary .carousel-arrow .icon.has-icons-right:hover {
  color: #ffffff;
  border-radius: 6px;
  background-color: rgba(19, 40, 57, 0.4);
}
.matchbymatch-summary .carousel-arrow .icon.has-icons-left:hover {
  color: #ffffff;
  border-radius: 6px;
  background-color: rgba(19, 40, 57, 0.4);
}
.matchbymatch-summary .carousel-arrow .icon.has-icons-right {
  right: 32.8vw !important;
  top: 28.626vw !important;
}
.matchbymatch-summary .carousel-arrow .icon.has-icons-left {
  left: 32.8vw !important;
  top: 28.626vw !important;
}
@media screen and (max-width: 1600px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 32.8vw !important;
    top: 29.126vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 32.8vw !important;
    top: 29.126vw !important;
  }
}
@media screen and (max-width: 1400px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 32.8vw !important;
    top: 29.526vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 32.8vw !important;
    top: 29.526vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon {
    color: #ffffff;
    width: 120px;
    border-radius: 6px;
    background-color: rgba(19, 40, 57, 0.4);
  }
}
@media screen and (max-width: 1280px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 32.8vw !important;
    top: 30.026vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 32.8vw !important;
    top: 30.026vw !important;
  }
}
@media screen and (max-width: 1200px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 24.2vw !important;
    top: 37.826vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 24.2vw !important;
    top: 37.826vw !important;
  }
}
@media screen and (max-width: 1080px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 24.2vw !important;
    top: 38.526vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 24.2vw !important;
    top: 38.526vw !important;
  }
}
@media screen and (max-width: 1024px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 25.5vw !important;
    top: 38.526vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 25.5vw !important;
    top: 38.526vw !important;
  }
}
@media screen and (max-width: 1000px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 25.5vw !important;
    top: 39.7vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 25.5vw !important;
    top: 39.7vw !important;
  }
}
@media screen and (max-width: 920px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 25.5vw !important;
    top: 40.1vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 25.5vw !important;
    top: 40.1vw !important;
  }
}
@media screen and (max-width: 855px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 25.5vw !important;
    top: 40.6vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 25.5vw !important;
    top: 40.6vw !important;
  }
}
@media screen and (max-width: 800px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 25.5vw !important;
    top: 41.6vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 25.5vw !important;
    top: 41.6vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon {
    color: #ffffff;
    width: 90px;
    border-radius: 6px;
    background-color: rgba(19, 40, 57, 0.4);
  }
}
@media screen and (max-width: 768px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 1.4vw !important;
    top: 64vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 1.4vw !important;
    top: 64vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon {
    color: #ffffff;
    width: 140px;
    border-radius: 6px;
    background-color: rgba(19, 40, 57, 0.4);
  }
}
@media screen and (max-width: 660px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 1.4vw !important;
    top: 65.2vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 1.4vw !important;
    top: 65.2vw !important;
  }
}
@media screen and (max-width: 590px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 1.4vw !important;
    top: 66.8vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 1.4vw !important;
    top: 66.8vw !important;
  }
}
@media screen and (max-width: 540px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 1.4vw !important;
    top: 67.5vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 1.4vw !important;
    top: 67.5vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon {
    color: #ffffff;
    width: 110px;
    border-radius: 6px;
    background-color: rgba(19, 40, 57, 0.4);
  }
}
@media screen and (max-width: 500px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 1.4vw !important;
    top: 110.5vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 1.4vw !important;
    top: 110.5vw !important;
  }
  .matchbymatch-summary .carousel-indicator {
    display: none !important;
  }
  .matchbymatch-summary .carousel-arrow .icon {
    color: #ffffff;
    width: 80px;
    height: 32px;
    border-radius: 6px;
    background-color: rgba(19, 40, 57, 0.4);
  }
}
@media screen and (max-width: 450px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 1.4vw !important;
    top: 112.5vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 1.4vw !important;
    top: 112.5vw !important;
  }
}
@media screen and (max-width: 380px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 1.4vw !important;
    top: 115.5vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 1.4vw !important;
    top: 115.5vw !important;
  }
}
@media screen and (max-width: 300px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 1.4vw !important;
    top: 118.5vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 1.4vw !important;
    top: 118.5vw !important;
  }
}
@media screen and (max-width: 250px) {
  .matchbymatch-summary .carousel-arrow .icon.has-icons-right {
    right: 1.4vw !important;
    top: 122.5vw !important;
  }
  .matchbymatch-summary .carousel-arrow .icon.has-icons-left {
    left: 1.4vw !important;
    top: 122.5vw !important;
  }
}
</style>
<style scoped lang="scss">
.cont-row-statstype {
  width: 98%;
  margin: 0 auto;
  height: auto;
  display: grid;

  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  @media screen and (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 500px) {
    grid-template-columns: 1fr;
  }

  gap: 20px;
  margin-top: 20px;
  margin-bottom: 40px;
}
</style>
